/*eslint-disable*/
import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import { useNavigate, useParams } from "react-router-dom";
import MailOutline from "@material-ui/icons/MailOutline";
import Slider from "nouislider";
import ImageUpload from "components/CustomUpload/ImageUpload.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import Datetime from "react-datetime";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import axios from "../../utils/axiosInstance";
import defaultImage from "assets/img/image_placeholder.jpg";
import defaultAvatar from "assets/img/placeholder.jpg";
import { Formik, Form, Field, ErrorMessage } from "formik";
import styles from "assets/jss/material-dashboard-pro-react/views/validationFormsStyle.js";
import SweetAlert from "react-bootstrap-sweetalert";

import stylesData from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";

const useStyleData = makeStyles(stylesData);
import moment from "moment";

import PromotionSchema from "utils/PromotionBuyTicketSchema";
import { CircularProgress } from "@material-ui/core";


const useStyles = makeStyles(styles);
const isValidDate = (current) => {
  const now = new Date();
  now.setHours(0, 0, 0, 0);
  const yesterday = Datetime.moment().subtract(1, "day");
  return current.isAfter(yesterday);
};

const handleKeyPress = (e) => {
  const char = String.fromCharCode(e.which);
  const isValidChar = /^[0-9/: -]+$/.test(char);
  if (!isValidChar) {
    e.preventDefault();
  }
};


export default function ManagePromotion() {

  let fileInput = React.createRef();
  const [loading, setLoading] = React.useState(false);
  const navigate = useNavigate();

  let { id } = useParams();
  const [errors, setErrors] = useState({});
  const [initialValues, setInitialValues] = useState({
    rewardAmount: null,
    couponCode: "",
    startDateTime: null,
    endDateTime: null,
    usesPerCoupon: 1,
    promotionName: "",
    status: null,
    minimumCartValue: "",
    discountType: "",
    comments: "",
    lotteryId: "",
    image: null,
  });
  const [isEditDataLoaded, setIsEditDataLoaded] = React.useState(!id);

  const [simpleSelect, setSimpleSelect] = React.useState("");
  const [selectedDate, setSelectedDate] = React.useState(null);
  const [selectedTime, setSelectedTime] = React.useState(null);
  const [file, setFile] = React.useState(null);
  const [alert, setAlert] = React.useState("");
  const [avatar, setAvatar] = React.useState(false);
  const [imagePreviewUrl, setImagePreviewUrl] = React.useState(defaultAvatar);
  const [promotionData, setPromotionData] = React.useState([]);

  React.useEffect(() => {
    if (id) {
      const fetchData = async () => {
        const token = localStorage.getItem("token");
        try {
          const res = await axios.get(
            `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/promotiondetail/${id}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Access-Control-Allow-Origin": "*",
              },
            }
          );
          const data = res.data.data;
          setInitialValues({
            rewardAmount: data?.rewardAmount || null,
            couponCode: data?.couponCode || "",
            startDateTime: new Date(data.startDateTime),
            endDateTime: new Date(data.endDateTime),
            usesPerCoupon: data?.usesPerCoupon || 1,
            promotionName: data?.promotionName || "",
            status: data?.status,
            minimumCartValue: data?.minimumCartValue || "",
            discountType: data?.discountType || "",
            comments: data?.comments || "",
            lotteryId: data?.lotteryId || "",
            image: data?.image || "",
          });
          if (data.image) {
            setImagePreviewUrl(
              `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/uploads/${data?.image}`
            );
          }
          setIsEditDataLoaded(true);
        } catch (error) {
          console.error(error.message);
          if (
            error?.response?.data?.message ===
            "For security reasons, we locked your account.Please login to continue"
          ) {
            localStorage.removeItem("token");
            window.location.assign("/auth/login-page");
          }
        }
      };

      fetchData();
    }
  }, [id]);

  const hideAlert = () => {
    setAlert(null);
    navigate("/admin/ManagePromotion", { state: { refresh: true } });
  };

  const handleImageChange = (e, setFieldValue, setFieldTouched) => {
    e.preventDefault();
    const reader = new FileReader();
    const file = e.target.files[0];

    if (file) {
      reader.onloadend = () => {
        setAvatar(true);
        setFile(file);
        setImagePreviewUrl(reader.result);


        setFieldValue("image", file);
        setFieldTouched("image", true);
      };
      reader.readAsDataURL(file);
    }
  };
  const handleSimple = (e, setFieldValue) => {
    const { name, value } = e.target;
    setFieldValue(name, value);
    setSimpleSelect(value); // if needed for UI behavior
  };

  const handleChange = (e, setFieldValue) => {
    const { id, type, value } = e.target;
    const parsedValue = type === "number" ? Number(value) : value;
    setFieldValue(id, parsedValue);
  };

  const handleDateTimeChange = (value, setFieldValue, setFieldError) => {
    const isValidMoment = moment.isMoment(value) && value.isValid();
    if (isValidMoment) {
      setFieldValue("startDateTime", value.toISOString());
    } else {
      setFieldError("startDateTime", "Invalid date and time.");
    }
  };

  const handleEndDateTimeChange = (value, setFieldValue, setFieldError) => {
    const isValidMoment = moment.isMoment(value) && value.isValid();
    if (isValidMoment) {
      setFieldValue("endDateTime", value.toISOString());
    } else {
      setFieldError("endDateTime", "Invalid date and time.");
    }
  };

  const handleRemove = (setFieldValue) => {
    setFile(null);
    setImagePreviewUrl(defaultAvatar);
    setAvatar(false);

    // Clear from Formik
    setFieldValue("image", null);
  };


  const classes = useStyles();
  const classesSweetAlert = useStyleData();

  React.useEffect(() => {
    const fetchPromotionData = async () => {
      const token = localStorage.getItem("token");
      try {
        await axios
          .get(
            `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/getfutureLottery`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Access-Control-Allow-Origin": "*",
              },
            }
          )
          .then((res) => {
            setPromotionData(res.data.data);

          });
      } catch (error) {
        console.error(error.message);
        if (
          error?.response?.data?.message ==
          "For security reasons, we locked your account.Please login to continue"
        ) {
          localStorage.removeItem("token");
          window.location.assign("/auth/login-page");
        }
      }


    }
    fetchPromotionData();
  }, []);
  return (
    <>
      <Formik
        initialValues={initialValues}
        enableReinitialize={true}
        validationSchema={PromotionSchema}
        onSubmit={async (values, { setSubmitting, resetForm }) => {
          setLoading(true);
          const token = localStorage.getItem("token");
          const formData = new FormData();

          for (const key in values) {
            if (key !== "image") {
              let valueToAppend = values[key];

              if (
                (key === "startDateTime" || key === "endDateTime") &&
                valueToAppend
              ) {
                if (typeof valueToAppend === "string") {
               
                } else if (
                  valueToAppend instanceof Date
                ) {
                  
                  valueToAppend = valueToAppend.toISOString();
                } else if (
                  typeof valueToAppend.utc === "function"
                ) {
                 
                  valueToAppend = valueToAppend.utc().format();
                } else {
                  console.warn(`Unknown date format for ${key}:`, valueToAppend);
                  valueToAppend = "";
                }
              }

              formData.append(key, valueToAppend);
            }
          }

          if (file) {
            formData.append("image", file);
          }

          formData.append("rewardBy", "Buy Tickets");
          try {
            let response;
            const headers = { Authorization: `Bearer ${token}` };
            if (id) {
              response = await axios.put(
                `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/promotion/${id}`,
                formData,
                { headers }
              );
            } else {
              response = await axios.post(
                `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/promotion`,
                formData,
                { headers }
              );
            }

            setAlert(
              <SweetAlert
                style={{ display: "block", marginTop: "-100px" }}
                title={<span style={{ fontSize: "14px", fontWeight: "bold" }}>{response.data.message}</span>}
                onConfirm={hideAlert}
                onCancel={hideAlert}
                titleCssClass={classesSweetAlert.cardTitle}
                confirmBtnCssClass={`${classesSweetAlert.button} ${classesSweetAlert.success}`}
              />
            );

            resetForm();
            setFile(null);
            setImagePreviewUrl(null);
          } catch (error) {
            let errorMsg = "An error occurred, please try again.";
            if (error.response) {
              errorMsg = error.response.data?.message || errorMsg;
            }

            setAlert(
              <SweetAlert
                style={{ display: "block", marginTop: "-100px" }}
                title={<span style={{ fontSize: "14px", fontWeight: "bold" }}>{errorMsg}</span>}
                onConfirm={hideAlert}
                onCancel={hideAlert}
                titleCssClass={classesSweetAlert.cardTitle}
                confirmBtnCssClass={`${classesSweetAlert.button} ${classesSweetAlert.success}`}
              />
            );
          }

          setSubmitting(false);
          setLoading(false);
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
          setFieldTouched,
          submitCount,
          isSubmitting, dirty
        }) => (
          <Form onSubmit={handleSubmit}>
            <GridContainer>
              <GridItem xs={12} sm={12} md={12}>
                <Card>
                  <CardHeader color="rose" icon>
                    <CardIcon color="rose">
                      <MailOutline />
                    </CardIcon>
                    <h4 className={classes.cardIconTitle}>
                      {id ? "Edit Promotion Buy Ticket" : "Create Promotion Buy Ticket"}
                    </h4>
                  </CardHeader>
                  <CardBody>
                    <form>
                      <GridContainer>
                        <div style={{ color: "white" }}>.</div>
                        <GridItem xs={12} sm={4} md={12}>
                          <ImageUpload
                            avatar
                            fileValue={file}
                            handleRemove={() => handleRemove(setFieldValue)}
                            imagePreviewUrlValue={imagePreviewUrl}
                            handleImageChange={(e) => handleImageChange(e, setFieldValue, setFieldTouched)}
                            addButtonProps={{
                              color: "rose",
                              round: true,
                            }}
                            changeButtonProps={{
                              color: "rose",
                              round: true,
                            }}
                            removeButtonProps={{
                              color: "danger",
                              round: true,
                            }}
                          />
                          {(touched.image || submitCount > 0) && errors.image && (
                            <div style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>
                              {errors.image}
                            </div>
                          )}
                        </GridItem>
                        <GridItem xs={12} sm={12} md={3}>
                          <CustomInput
                            labelText="Promotion Name"
                            id="promotionName"
                            name="promotionName"
                            handleChange={handleChange}
                            formControlProps={{
                              fullWidth: true,
                            }}
                            inputProps={{
                              type: "text",
                              name: "promotionName",
                              value: values.promotionName,
                              onChange: handleChange,
                            }}
                            error={touched.promotionName && !!errors.promotionName}
                            helperText={touched.promotionName && errors.promotionName}
                          />
                        </GridItem>
                        <GridItem xs={12} sm={12} md={3} style={{ marginTop: "10px" }}>
                          <FormControl fullWidth error={!!errors.lotteryId}>
                            <InputLabel id="lotteryId-label">Select Lottery</InputLabel>
                            <Select
                              labelId="lotteryId-label"
                              id="lotteryId"
                              name="lotteryId"
                              value={values.lotteryId}
                              onChange={handleChange}
                            >
                              {promotionData.length > 0 ? (
                                promotionData.map((lottery) => (
                                  <MenuItem key={lottery._id} value={lottery._id}>
                                    {lottery.lotteryName}
                                  </MenuItem>
                                ))
                              ) : (
                                <MenuItem disabled>No lottery available</MenuItem>
                              )}
                            </Select>
                            {touched.lotteryId && errors.lotteryId && (
                              <p style={{ color: "red", fontSize: "0.875rem" }}>{errors.lotteryId}</p>
                            )}
                          </FormControl>
                        </GridItem>

                        <GridItem xs={12} sm={12} md={3}>
                          <CustomInput
                            type="number"
                            labelText="Number of Free Ticket"
                            id="rewardAmount"
                            formControlProps={{
                              fullWidth: true,
                            }}
                            handleChange={handleChange}
                            inputProps={{
                              type: "number",
                              value: values.rewardAmount,
                              min: 0,
                              onKeyDown: (e) => {

                                if (["-", "e"].includes(e.key)) {
                                  e.preventDefault();
                                }


                                if (e.key === "ArrowDown" && formValues.rewardAmount <= 0) {
                                  e.preventDefault();
                                }
                              },
                            }}
                            error={touched.rewardAmount && !!errors.rewardAmount}
                            helperText={touched.rewardAmount && errors.rewardAmount}
                          />
                        </GridItem>
                        <GridItem xs={12} sm={12} md={3}>
                          <CustomInput
                            labelText="Coupon Code"
                            id="couponCode"
                            handleChange={handleChange}
                            formControlProps={{
                              fullWidth: true,
                            }}
                            inputProps={{
                              type: "text",
                              value: values.couponCode,
                            }}
                            error={touched.couponCode && !!errors.couponCode}
                            helperText={touched.couponCode && errors.couponCode}
                          />
                        </GridItem>

                        <GridItem xs={12} sm={12} md={3}>
                          <InputLabel className={classes.label}>
                            Start Date and Time
                          </InputLabel>
                          <br />
                          <FormControl fullWidth>
                            <Datetime
                              value={values.startDateTime}
                              onChange={(val) => setFieldValue("startDateTime", val)}
                              Create Promotion Buy Ticket
                              inputProps={{ placeholder: "Start Date" }}
                              isValidDate={isValidDate}
                            />
                            {touched.startDateTime && errors.startDateTime && (
                              <p style={{ color: "red", fontSize: "0.775rem" }}>{errors.startDateTime}</p>
                            )}
                          </FormControl>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={3}>
                          <InputLabel className={classes.label}>
                            End Date and Time
                          </InputLabel>
                          <br />
                          <FormControl fullWidth>
                            <Datetime
                              value={values.endDateTime}
                              onChange={(val) => setFieldValue("endDateTime", val)}
                              inputProps={{ placeholder: "End Date" }}
                              isValidDate={isValidDate}
                            />
                            {touched.endDateTime && errors.endDateTime && (
                              <p style={{ color: "red", fontSize: "0.775rem" }}>{errors.endDateTime}</p>
                            )}
                          </FormControl>
                        </GridItem>

                        <GridItem xs={12} sm={12} md={3}>
                          <CustomInput
                            labelText="Promotion Details"
                            id="comments"
                            handleChange={handleChange}
                            formControlProps={{
                              fullWidth: true,
                            }}
                            inputProps={{
                              type: "text",
                              value: values.comments,
                            }}
                          />
                        </GridItem>
                        <GridItem xs={12} sm={12} md={3} style={{ marginTop: "10px" }}>
                          <FormControl
                            fullWidth
                            className={classes.selectFormControl}
                          >
                            <InputLabel
                              htmlFor="simple-select"
                              className={classes.selectLabel}
                              shrink={true}
                            >
                              Status
                            </InputLabel>
                            <Select
                              id="status"
                              MenuProps={{
                                className: classes.selectMenu,
                              }}
                              classes={{
                                select: classes.select,
                              }}
                              value={values.status}
                              onChange={handleChange}
                              inputProps={{
                                name: "status",
                                id: "status",
                              }}
                            >
                              <MenuItem
                                classes={{
                                  root: classes.selectMenuItem,
                                  selected: classes.selectMenuItemSelected,
                                }}
                                value={true}
                              >
                                Active
                              </MenuItem>
                              <MenuItem
                                classes={{
                                  root: classes.selectMenuItem,
                                  selected: classes.selectMenuItemSelected,
                                }}
                                value={false}
                              >
                                Inactive
                              </MenuItem>
                            </Select>
                            {touched.status && errors.status && (
                              <p style={{ color: "red", fontSize: "0.875rem" }}>{errors.status}</p>
                            )}
                          </FormControl>
                        </GridItem>
                      </GridContainer>
                    </form>
                    {loading ? (<CircularProgress size={20} color="primary" />) : (<button
                      color="rose"
                      type="submit"
                      className="registerButtonBuy-9"

                    >
                      Save
                    </button>)}

                    {alert}
                  </CardBody>
                </Card>
              </GridItem>
            </GridContainer>
          </Form>
        )}
      </Formik>
    </>
  );
}
